import React from "react";
import "./Post.css";
import { CommentIcon, ShareIcon, KebabIcon } from "./icons";
import * as Ph from "@phosphor-icons/react";

import StarRatingV2 from "./components/StarRatingV2/StarRatingV2";
import RichCaption from "./components/RichCaption";
import PostCarousel from "./components/PostCarousel";
import FeedVideo from "./components/FeedVideo";
import { resolveVideoUrl } from "./utils/videoSource";
import PostImage from "./components/PostImage";
import { usePostLogic, kisaltAciklama } from "./hooks/usePostLogic";
import ShareSheet from "./components/ShareSheet";
import ReportModal, { SikayetHedefi } from "./components/ReportModal";
import { REPORT_TARGET_TYPE } from "./constants/reportSchema";
import { useCachedMyRating } from "./utils/myRatingsCache";
import { formatTimeAgoShort, formatCount } from "./utils";
// Makine-okunur zaman TEK otoriteden (mobil ikiziyle aynı sözleşme).
import { damgaAttr, baslikAttr } from "./gonderiZamanDamgasi";
// #888 — bayat göreli zaman: TEK paylaşılan tik (kart başına setInterval YOK).
import { useGoreliZamanTiki } from "./hooks/useGoreliZamanTiki";
import { DEFAULT_AVATAR_NEUTRAL } from "./utils/avatar";
import { IkonKoprusu } from "./icon-system/runtime/IkonKoprusu";
import PostActionsBar from "./components/PostActionsBar/PostActionsBar";
import PostRatingSummary from "./components/PostRatingSummary/PostRatingSummary";
import { boyutCoz } from "./icon-system/adapters/boyut";

/* ── 🔴 ÖLÇÜLEN YERLEŞİM REGRESYONU (motor kolu) ──────────────────────────
   `Post.css:113` `.postDk-optionsBtn svg { width:28px; height:28px }` ESKİ kolda
   çalışıyordu, çünkü Phosphor kutuyu `width`/`height` ÖZNİTELİĞİYLE verir ve CSS
   özniteliği EZER. `IconFrame` ise kutuyu SATIR-İÇİ `style` ile yazar; satır-içi
   stil her zaman kazanır → stil sayfasının 28'i ölü kalır, kutu `md` (24 px) olur.
   Ölçüldü (gerçek Chromium, ürünün kendi CSS'iyle; koşum: r1/olcum.js):
       `.postDk-header`   71 → 67 px        (−4)
       `.postDk-article`  610,59 → 606,59   (−4)   `.postDk-actions` top −4
   Owner talimatı: MEVCUT 28 px kutu ölçüsü KORUNACAK. O yüzden 28, stil
   sayfasından ÇAĞRI YERİNE taşınır — dalga 1/2/4'ün emsali (`BottomNav` size=28,
   `FeedVideo` size=14, `NewPost` 13/14/15/26): token dışı px KORUNUR ve borç
   `data-boyut-px` ile DOM'da GÖRÜNÜR. 28 bir token DEĞİL (16/20/24/32) → yeni
   sabit-px borcu EKLENMEZ, zaten üründe olan borç görünür kılınır.
   Modül seviyesi: render başına nesne yok. Bayrak KAPALI → yalnız `eski` çizilir,
   bu nesne hiç okunmaz → piksel-birebir. */
const _b28 = boyutCoz(28);
const MOTOR_BOYUT_28 = { boyut: _b28.boyut, kutuPx: _b28.kutuPx, "data-boyut-px": _b28.borc };

/* İkon satır kutusu — KULLANIM_SOZLESMESI §4 ORTAK ÇÖZÜM: kip/kutu/hiza garantisi
   `IkonKoprusu satirIci` → `IconFrame` (inline-block · --ikon-kullanim-metin ·
   --ikon-metin-hiza); çağrı-yeri yaması söküldü. */

/* ── EYLEM RAYI — `content.share` 22 px İSTİSNASI GERİ ALINDI (2026-09-12) ──
   Mobil ikizin eşi; gerekçenin tam metni `PostMobile.tsx` `RAY_PAYLAS_OPTIK`
   bloğunda. Özet: `docs/ikon/KULLANIM_SOZLESMESI.md` §0.3 bu küçültmeyi
   "ajan tercihi → geri alınacak" diye sınıflıyor (owner: *"mürekkep miktarını
   eşitlemek için ikonları bozma"*), §2.1 aksiyon kategorisini **24 px** olarak
   kilitliyor. Kutu artık komşularıyla aynı `md`. */

const PostSkeleton = () => (
  <article className="postDk-article skeleton" aria-busy="true" aria-live="polite">
    <header className="postDk-header">
      <div className="skeleton-avatar" />
      <div className="skeleton-text skeleton-username" />
    </header>
    <div className="skeleton-media" />
    <div className="postDk-content">
      <div className="skeleton-text" />
      <div className="skeleton-text short" />
    </div>
  </article>
);

const FeedVideoAny = FeedVideo as any;

function Post({ post, aktifKullaniciId, onUserClick, onCommentClick }: any) {
  // #888 — göreli zaman («2 saat önce») TEK paylaşılan tikle tazelenir.
  // Kart başına zamanlayıcı KURULMAZ: kaç kart olursa olsun uygulamada
  // toplam `setInterval` sayısı 1'dir (bkz. useGoreliZamanTiki başlığı).
  useGoreliZamanTiki();
  // PR-63 — cihaz-kalıcı kendi puanım (local map lookup + pub/sub; ağır iş yok).
  const myCachedRating = useCachedMyRating(aktifKullaniciId, post?.id);
  const {
    authorProfile,
    isSaved,
    optionsOpen,
    setOptionsOpen,
    isMediaLoaded,
    setIsMediaLoaded,
    showFullCaption,
    setShowFullCaption,
    agg,
    menuRef,
    isOwner,
    visibleScore,
    showGold,
    handleDelete,
    handleToggleSave,
    handleShare,
    // P1-4/P1-5 — paylaş sheet'i (kart ✈️ artık `window.alert` açmıyor).
    shareOpen,
    setShareOpen,
    permalink,
    shareAttachment,
    handleToggleComments,
    handleGoToPost,
    handleRate,
    editOpen,
    editText,
    setEditText,
    openEdit,
    cancelEdit,
    saveEdit,
    showBurst,
    handleMediaTap,
    rateOpenNonce,
  } = usePostLogic(post, aktifKullaniciId, onCommentClick);
  const [sikayetHedefi, setSikayetHedefi] = React.useState<SikayetHedefi | null>(null);

  if (!authorProfile) return <PostSkeleton />;

  const mediaUrl = post.mediaUrl;
  const mediaType = post.mediaType || "image";
  // Carousel: mediaItems varsa onu kullan; eski gönderiler tekil alanlardan gelir.
  const mediaItems = Array.isArray(post.mediaItems) && post.mediaItems.length
    ? post.mediaItems
    : (mediaUrl ? [{ url: mediaUrl, type: mediaType.startsWith("video") ? "video" : "image" }] : []);
  const username = authorProfile?.kullaniciAdi || "bilinmeyen";
  const avatarUrl =
    authorProfile?.profilFoto || DEFAULT_AVATAR_NEUTRAL;

  // Kısaltma eşiği + türetim `usePostLogic`e taşındı (satır-içi kopya YOK):
  // mobil ikizi de aynı noktadan kesmek zorunda; iki kopya bir gün çatallanır
  // (kanon, `formatTimeAgoShort` sınıfı). Davranış deltası SIFIR — aynı 140.
  const { needsClamp, preview: captionPreview, text: captionText } = kisaltAciklama(post?.mesaj);

  return (
    <article className="postDk-article">
      <header className="postDk-header">
        <div
          className={`postDk-avatarWrap ${showGold ? "gold" : ""}`}
          onClick={() => onUserClick?.(post.authorId)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => (e.key === "Enter" ? onUserClick?.(post.authorId) : null)}
          aria-label={`${username} profilini aç`}
        >
          <img src={avatarUrl} alt={username} className="postDk-avatar" draggable="false" />
          {/* ANLAM (§7 "5★ puanlama ↔ Gold Star itibarı birleştirilmez"): yazarın
              Gold Star STATÜSÜ; `reputation.goldStar` (halka+yıldız) ailesi manifestte
              zaten var ve `Bildirimler.tsx mycards_gold` bunu kullanıyor. `eski` aynı
              "★" karakteri → bayrak kapalı kolda DOM birebir. Motor kolunda `style`:
              `.postDk-goldStar` altını `background-clip:text` + `color:transparent`
              ile METNE boyuyor; svg metin değil → `currentColor` şeffaf kalır ve ikon
              GÖRÜNMEZ olurdu. Altın token'ı (`--renk-yildiz-altin`, K7: Gold Star
              altın taşıyabilir) satır-içi verilir; yeni ham renk YOK. Boyut sm (20 px)
              = mevcut `font-size: 20px` ile aynı kutu. */}
          {showGold && <span className="postDk-goldStar" aria-hidden="true"><IkonKoprusu aile="reputation.goldStar" boyut="sm" style={{ color: "var(--renk-yildiz-altin)" }} eski="★" /></span>}
        </div>

        <div className="postDk-userMeta" onClick={() => onUserClick?.(post.authorId)}>
          <span className="postDk-username">{username}</span>
          {/* İtibar rozeti YALNIZ gerçek bir ortalama varsa. Eskiden koşulsuzdu
              ve alan yokken `Number(undefined→0).toFixed(1)` = "★ 0.0"
              basıyordu; aynı kartın altında gerçek içerik puanı ("4.5★ ·
              2 puan") dururken iki çelişik sayı çıkıyordu. Kanon (K1):
              yolculuk hâlinde UI'de SAYI GÖSTERİLMEZ. Mobil ikizde bu rozet
              zaten hiç yok → gizlemek pariteyi de düzeltir. */}
          {visibleScore !== null && (
            <span className="postDk-repPill" title="Topluluk puanı">
              <span className="rep-star">★</span>
              <span className="rep-value">{visibleScore.toFixed(1)}</span>
            </span>
          )}
          {/* `satirIci` — §4 ortak çözüm (ikon bileşeni garanti eder). KALDIRMA →
              konum/kişi işareti metnin üstüne çıkar (`.postDk-location` +16 px). */}
          {post?.konum && (
            <span className="postDk-location" title="Konum"><IkonKoprusu aile="place.pin" boyut="xs" satirIci eski="📍" /> {post.konum}</span>
          )}
          {/* `postDk-tagged` (bu turda eklendi) — ÖLÇÜLEN DAYANIKSIZLIK:
              uzun kullanıcı adı + uzun mekân adı olan gönderide (sahne e,
              1440×900) bu öğe flex'te EZİLİYORDU: genişlik 45,09 → **23,84 px**,
              yükseklik 14,59 → **42,59 px** — yani "7 kişi" üç satıra kırılıp
              ikonunu metninden 14,39 px yukarıda bırakıyordu (`ustFark`).
              Owner: *"Uzun isim ve mekânlarda düzen dayanıklı olsun; yalnız
              kısa test verisiyle güzel görünmesin."* Çare KESMEK değil
              (KULLANIM_SOZLESMESI §4 yasaklıyor): bu öğe zaten en fazla
              "N kişi" kadar kısa → küçültülmez (`flex-shrink:0`), esneme
              payını uzun mekân adı alır ve o DOĞAL olarak sarar. */}
          {Array.isArray(post?.taggedUids) && post.taggedUids.length > 0 && (
            <span className="postDk-location postDk-tagged" title="Etiketlenenler">
              {/* ANLAM (§7): "N kişi" = ETİKETLENEN kişiler (title "Etiketlenenler");
                  profil/hesap değil → `profile.tabTagged` (sekmeyle aynı aile).
                  `eski` 👤 aynen. */}
              <IkonKoprusu aile="profile.tabTagged" boyut="xs" satirIci eski="👤" /> {post.taggedUids.length} kişi
            </span>
          )}
        </div>

        <div className="postDk-options" ref={menuRef}>
          {/* a11y (#981): axe `button-name` (CRITICAL) — MASAÜSTÜNDE ölçüldü.
              Bu düğmenin MOBİL İKİZİ (`PostMobile.tsx:107`, `.pm-kebab`) tam
              olarak bu kusur için #973'te onarılmıştı; masaüstü kopyası
              onarılmadan kaldı çünkü axe o gün YALNIZ mobil profilde
              koşuyordu (`eye.js`: `vp.key === "mobile"`).
              🧭 Onarım profil sınırında durdu ve kimse göremedi: ölçüm
                 kapsamının şekli, borcun şeklini belirliyordu.
              WCAG 2.5.3 (Label in Name) çakışması YOK: düğmenin görünür
              metni yoktur (salt `<KebabIcon />`), dolayısıyla `aria-label`
              çelişen bir ad değil, TEK addır. */}
          <button
            className="postDk-optionsBtn pressable"
            onClick={() => setOptionsOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={optionsOpen}
            aria-controls="post-menu"
            aria-label="Gönderi seçenekleri"
          >
            {/* FAZ C / DALGA 2 — elle: `KebabIcon` (varsayılan direction=vertical → action.moreVertical); ESLEME `menu-vertical|menu` belirsiz saydığı için codemod sarmadı.
                `MOTOR_BOYUT_28`: kutu ölçüsü stil sayfasından buraya taşındı (üstteki
                blok — satır-içi stil CSS'i ezdiği için 28 ölüyordu). KALDIRMA → kart
                yeniden 4 px kısalır. */}
            <IkonKoprusu aile="action.moreVertical" {...MOTOR_BOYUT_28} eski={<KebabIcon />} />
          </button>
          {optionsOpen && (
            <div id="post-menu" className="postDk-optionsMenu" role="menu">
              <button onClick={handleGoToPost} className="option-item pressable" role="menuitem">Gönderiye git</button>
              {isOwner && (
                <button onClick={openEdit} className="option-item pressable" role="menuitem">Açıklamayı düzenle</button>
              )}
              {isOwner && (
                <button onClick={handleToggleComments} className="option-item pressable" role="menuitem">
                  {post?.yorumlarKapali ? "Yorumları aç" : "Yorumları kapat"}
                </button>
              )}
              {isOwner && (
                <button onClick={handleDelete} className="option-item delete pressable" role="menuitem">Sil</button>
              )}
              {!isOwner && (
                <button
                  onClick={() => {
                    setOptionsOpen(false);
                    setSikayetHedefi({ targetType: REPORT_TARGET_TYPE.POST, targetId: String(post?.id || "") });
                  }}
                  className="option-item pressable"
                  role="menuitem"
                >Şikayet et</button>
              )}
              <button onClick={() => setOptionsOpen(false)} className="option-item pressable" role="menuitem">Vazgeç</button>
            </div>
          )}
        </div>
      </header>

      <div className="postDk-media">
        {!isMediaLoaded && <div className="media-placeholder skeleton-media" aria-hidden="true" />}
        {mediaItems.length > 1 ? (
          <PostCarousel
            items={mediaItems}
            altText={post?.altText}
            onMediaClick={handleMediaTap}
            onFirstLoad={() => setIsMediaLoaded(true)}
          />
        ) : mediaItems.length === 1 && (mediaItems[0].type !== "video" ? (
          <PostImage
            src={mediaItems[0].url}
            alt={post?.altText || "Gönderi görseli"}
            className={`postDk-image ${isMediaLoaded ? "loaded" : ""}`}
            w={mediaItems[0].w}
            h={mediaItems[0].h}
            onLoad={() => setIsMediaLoaded(true)}
            onClick={handleMediaTap}
          />
        ) : (
          <FeedVideoAny
            /* PR-39 — R2/CDN-ready: cdnUrl varsa CDN, yoksa Firebase mediaUrl (bugün aynı). */
            src={resolveVideoUrl(post) || mediaItems[0].url}
            className={`postDk-video ${isMediaLoaded ? "loaded" : ""}`}
            poster={mediaItems[0].poster}
            w={mediaItems[0].w}
            h={mediaItems[0].h}
            onCanPlay={() => setIsMediaLoaded(true)}
            onClick={handleMediaTap}
          />
        ))}
        {showBurst && <div className="media-burst" aria-hidden="true">★</div>}
      </div>

      <div className="postDk-content">
        {/* EYLEM ŞERİDİ — ORTAK SUNUM BİLEŞENİ (owner, 2026-09-14:
            *"`Post.tsx` ve `ClipInFeed.tsx` bu bileşene bağlı değil."*).
            Masaüstünün DOM'u değişmedi (hücresiz şerit, ikonun kendi sınıfı);
            ortaklaşan şey SIRA + ÖLÇÜ + dokunma tabanı. */}
        <PostActionsBar
          onek="postDk"
          sayiBicimle={formatCount}
          yildiz={
            /* BUG FIX (2026-06-30): prop `onRated` (yanlış ad yüzünden puan
               Firestore'a hiç yazılmıyordu). #931: kendi gönderinde tetik
               `aria-disabled` + sebep BASINCA duyurulur. */
            <StarRatingV2
              className="postDk-actionBtn"
              size={24}
              contentId={post?.id}
              authorId={post?.authorId}
              type={post?.type || "post"}
              onRated={handleRate}
              openNonce={rateOpenNonce}
              disabled={isOwner}
              disabledReason="Kendi gönderine puan veremezsin"
            />
          }
          onYorum={() => onCommentClick?.(post)}
          eskiYorum={<CommentIcon size={24} weight="regular" className="postDk-actionIcon" />}
          onPaylas={handleShare}
          eskiPaylas={<ShareIcon size={24} weight="regular" className="postDk-actionIcon" />}
          onKaydet={handleToggleSave}
          kaydedildi={isSaved}
          eskiKaydet={<Ph.BookmarkSimple size={24} weight={isSaved ? "fill" : "regular"} className="postDk-actionIcon" />}
        />

        {/* ══ GÖNDERİ ÖZET SATIRI — mobil ikizi `.pm-meta` ile BİREBİR aynı
            gerekçe ve aynı üç-sinyalli ayrım (sözcük · biçim · ağırlık).
            Tam metin `PostMobile.tsx`teki blokta; iki yüzey TEK karar. */}
        {/* PUAN ÖZETİ — ORTAK BİLEŞEN (2026-09-14). Mobil ikiziyle AYNI
            karar; iki JSX kopyası tek bileşene indi. */}
        <PostRatingSummary
          onek="postDk"
          ortalama={agg && agg.avg > 0 && agg.count > 0 ? { avg: Number(agg.avg), count: Number(agg.count) } : null}
          benimPuanim={myCachedRating}
          kendiIcerigi={isOwner}
          sayiBicimle={formatCount}
        />

        {post?.yorumlarKapali && <div className="comments-locked">Yorumlar kapalı</div>}

        {/* KAMPANYA — esnaf postu: fiyat şeridi (süre dolunca "sona erdi") */}
        {post?.postType === 'kampanya' && post?.price?.amount > 0 && (
          <div className={`post-kampanya ${post?.validUntil?.toMillis && post.validUntil.toMillis() < Date.now() ? 'is-expired' : ''}`}>
            <span className="post-kampanya__badge">
              {post?.validUntil?.toMillis && post.validUntil.toMillis() < Date.now() ? 'KAMPANYA SONA ERDİ' : 'KAMPANYA'}
            </span>
            {post?.price?.oldAmount > 0 && (
              <s className="post-kampanya__old">{(post.price.oldAmount / 100).toLocaleString('tr-TR')} TL</s>
            )}
            <strong className="post-kampanya__new">{(post.price.amount / 100).toLocaleString('tr-TR')} TL</strong>
          </div>
        )}

        {editOpen ? (
          <div className="postDk-captionEdit">
            <textarea
              value={editText}
              maxLength={2200}
              onChange={(e) => setEditText(e.target.value)}
              aria-label="Açıklamayı düzenle"
            />
            <div className="postDk-captionEditBtns">
              <button type="button" className="save pressable" onClick={saveEdit}>Kaydet</button>
              <button className="pressable" type="button" onClick={cancelEdit}>İptal</button>
            </div>
          </div>
        ) : captionText && (
          <p className="postDk-caption">
            <strong onClick={() => onUserClick?.(post.authorId)}>{username}</strong>
            <span> <RichCaption text={showFullCaption ? captionText : captionPreview} /></span>
            {needsClamp && !showFullCaption && (
              <>
                <span>… </span>
                <button className="postDk-moreBtn pressable" onClick={() => setShowFullCaption(true)} aria-label="Devamını göster">
                  devamı
                </button>
              </>
            )}
          </p>
        )}

        {post?.yorumlar?.length > 0 && (
          <button className="postDk-commentsLink pressable" onClick={() => onCommentClick?.(post)}>
            Tüm {post.yorumlar.length} yorumu gör
          </button>
        )}

        {/* `<p>` → `<time>`: masaüstünde makine-okunur zaman HİÇ YOKTU.
            ⚠️ `<time>` satır-içi bir elemandır; `.postDk-date`in
            `padding-bottom:16px`i satır-içiyken yüksekliğe İŞLEMEZ →
            CSS'e `display:block` eklendi (Post.css). Ölçülmeseydi bu
            değişiklik 16px'i sessizce yutardı. */}
        <time
          className="postDk-date"
          dateTime={damgaAttr(post?.tarih)}
          title={baslikAttr(post?.tarih)}
        >
          {formatTimeAgoShort(post?.tarih)}
          {post?.duzenlendiAt && <span className="postDk-edited"> · düzenlendi</span>}
        </time>
      </div>
      {/* 🔴 EKSİKTİ (ölçüldü 2026-08-24): gönderiler ŞİKAYET EDİLEMİYORDU.
          Şikayet hattının TAMAMI hazırdı (callable + rate-limit + self-report
          guard + admin ekranı) ama `REPORT_TARGET_TYPE` gönderiyi tanımıyordu
          ve menüde satır yoktu → moderasyonun tek kullanıcı-tetikli girişi
          gönderiler için KAPALIYDI. IG paritesi: her gönderinin şikayet yolu
          vardır. Kendi gönderisi için gösterilmez (sunucu da reddeder). */}
      {/* P1-4/P1-5 — detayla AYNI paylaş sheet'i (DM'e gönder + bağlantıyı
          kopyala + varsa sistem paylaşımı). 🔗 URL YOK (kasıtlı, IG'de de
          yok); geri tuşu sheet'i kapatır (`BottomSheet` history girişi). */}
      <ShareSheet
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        permalink={permalink}
        attachment={shareAttachment}
      />
      <ReportModal
        open={!!sikayetHedefi}
        target={sikayetHedefi}
        onClose={() => setSikayetHedefi(null)}
      />
    </article>
  );
}
export default Post;


